var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyPlay = function SvgHappyPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M0 24C0 10.745 10.745 0 24 0c13.249.014 23.986 10.751 24 24 0 13.255-10.745 24-24 24S0 37.255 0 24m18.894 9.168 14.762-7.38v-.002a2 2 0 0 0 .002-3.586l-14.766-7.374A2 2 0 0 0 16 16.616V31.38a2 2 0 0 0 2.894 1.788",
    clipRule: "evenodd"
  })));
};
export default SvgHappyPlay;